export interface IdempotencyStore {
  get(key: string): string | null;
  set(key: string, value: string): void;
}

export interface IdSource {
  uuid(): string;
}

export class LeadIdempotency {
  constructor(
    private readonly store: IdempotencyStore,
    private readonly ids: IdSource,
  ) {}

  key(scope: string): string {
    const storageKey = `fg_lead_idempotency_${scope}`;
    const existing = this.store.get(storageKey);
    if (existing) return existing;
    const created = this.ids.uuid();
    this.store.set(storageKey, created);
    return created;
  }
}
